module.exports = __webpack_public_path__ + "static/media/AB_L31_8.eea3db14.jpg";